import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const BASE = "/struck-off-review"

// The monthly sweep never strikes anyone off. It records who the rules caught
// and a person decides each name — striking a child off is severe, and the
// data behind it is not always right.
export type ReviewCandidate = {
  _id: string
  student: string
  grNumber: string
  name: string
  className: string
  sectionName: string
  rule: "unpaid" | "absent"
  detail: string
  decision: "pending" | "confirmed" | "dismissed" | "no-longer-eligible"
  note: string
}

export type StruckOffReview = {
  _id: string
  runDate: string
  absenceMonth: string
  status: "pending" | "completed"
  absenceSkipReason: string
  candidates: ReviewCandidate[]
}

export const getPendingCount = async (branchId?: string): Promise<{ count: number }> => {
  const res = await apiClient({
    method: "GET",
    url: appendQueryParams(`${BASE}/pending-count`, { branchId }),
  })
  return res.data
}

export const listReviews = async (params: {
  branchId?: string
  status?: string
}): Promise<{ data: StruckOffReview[] }> => {
  const res = await apiClient({ method: "GET", url: appendQueryParams(BASE, params) })
  return res.data
}

// Runs the rules now instead of waiting for the 11th. Still only builds a list.
export const runReviewNow = async (branchId?: string) => {
  const res = await apiClient({ method: "POST", url: `${BASE}/run`, data: { branchId } })
  return res.data
}

// Confirming re-checks the rule first — a fee paid since the sweep means that
// name is skipped rather than struck off on a week-old list.
export const decideCandidates = async (
  reviewId: string,
  data: { studentIds: string[]; decision: "confirmed" | "dismissed"; note?: string }
): Promise<{
  success: boolean
  message: string
  changed: number
  dismissed: number
  skipped: number
}> => {
  const res = await apiClient({ method: "POST", url: `${BASE}/${reviewId}/decide`, data })
  return res.data
}
